module.exports = __webpack_public_path__ + "static/media/slide2.34e1ecdf.jpg";